/** Stable logical identities for this capability's owned fixed UDO templates. */
export enum FlexibleFitmentEngineWorkspaceCapabilityUdoTemplateKey {
    fitmentNode = "6308dee6-6f96-409b-b1f1-f0c81f318c40",
    compatibilityLink = "94e1c753-18e6-4ea1-bf79-44f9295db91c",
}
